import { render, staticRenderFns } from "./StaticInfoEdit.vue?vue&type=template&id=2408ef62"
import script from "./StaticInfoEdit.vue?vue&type=script&lang=js"
export * from "./StaticInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports